export const GUEST_ROUTES = {
	login: '/login',
	resetPassword: '/password-reset',
	forgotPassword: '/forgot-password',
	impersonate: '/impersonate',
	verifyEmailLink: '/email-link/verify',
	default: '/',
};

export const DASHBOARD_ROOT_ROUTE = '/dashboard';

export const UPSELL_RELATIVE_ROUTE = 'upsell';
export const UPSELL_ROOT_ROUTE = `${DASHBOARD_ROOT_ROUTE}/${UPSELL_RELATIVE_ROUTE}`;
export const MARKETING_UPSELL_ROUTE = `${UPSELL_ROOT_ROUTE}/marketing`;
export const CONTACT_CENTER_UPSELL_ROUTE = `${UPSELL_ROOT_ROUTE}/contact-center`;

export const REPORTS_ROOT_ROUTE = `${DASHBOARD_ROOT_ROUTE}/reports`;
export const REPORTS_ROOT_RELATIVE_ROUTE = 'reports';

export const PRE_BUILT_REPORT_ROUTE = `${REPORTS_ROOT_ROUTE}/pre-built`;
export const PRE_BUILT_REPORT_RELATIVE_ROUTE = `${REPORTS_ROOT_RELATIVE_ROUTE}/pre-built`;

export const CUSTOM_REPORT_ROUTE = `${REPORTS_ROOT_ROUTE}/custom`;
export const CUSTOM_REPORT_RELATIVE_ROUTE = `${REPORTS_ROOT_RELATIVE_ROUTE}/custom`;

export const CONFIGURED_REPORT_ROUTE = `${REPORTS_ROOT_ROUTE}/configured`;
export const CONFIGURED_REPORT_RELATIVE_ROUTE = `${REPORTS_ROOT_RELATIVE_ROUTE}/configured`;

export const LAUNDROWORKS_REPORTS_ROUTE = `${REPORTS_ROOT_ROUTE}/laundroworks`;
export const LAUNDROWORKS_REPORTS_RELATIVE_ROUTE = `${REPORTS_ROOT_RELATIVE_ROUTE}/laundroworks`;

export const REPORTS_BUILDER_ROUTE = `${REPORTS_ROOT_ROUTE}/builder`;
export const REPORTS_BUILDER_RELATIVE_ROUTE = `${REPORTS_ROOT_RELATIVE_ROUTE}/builder`;
